import { getUser } from '~src/user';

export const checkUserOwnership = async (item) => {
  const { user } = await getUser();
  if (item.org_pointer) {
    if (user.org_pointer.objectId === item.org_pointer.objectId) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
